import React from 'react'
import { z } from 'zod'
import { l, Icon, palettes } from '@manychat/manyui'

import { BlockType } from '../../constants'
import { useBillingInfo, useDefaultContext, useDidMountEffect } from '../../hooks'
import { registry } from '../../registry'
import { BlockProps } from '../../types'

const TaxEstimationRowPropsSchema = z.object({
  isInline: z.boolean().optional(),
})

const Component = ({ isInline = false }: BlockProps<typeof TaxEstimationRowPropsSchema>) => {
  const { is_tax_estimation_enabled } = useBillingInfo()
  const { sendEvent, request } = useDefaultContext()

  useDidMountEffect(() => {
    if (!is_tax_estimation_enabled) return
    sendEvent('PAYWALL.TAX_ESTIMATION.SHOWN', { source: request.source })
  })

  if (!is_tax_estimation_enabled) return null
  return (
    <>
      <div className="d-flex flex-row justify-between align-center">
        <div className="flex-row d-flex align-center gap-xxs">
          <span>{isInline ? l.translate('+ taxes') : l.translate('Estimated taxes')}</span>
          <Icon.Question
            size={16}
            color={palettes.typography.secondary}
            data-title={l.getString(
              'Taxes are estimated based on your location within the United States. The final amount will be confirmed after payment and can be found in your billing information or invoice',
            )}
            data-title-at="left"
            data-title-cls="text-center"
          />
        </div>
        {!isInline && <span>-</span>}
      </div>
    </>
  )
}

export const TaxEstimationRow = registry.register(Component, {
  props: TaxEstimationRowPropsSchema,
  type: BlockType.TAX_ESTIMATION_ROW,
})
